import { useSidebar } from "./sidebarContext";
import { Link } from "react-router-dom";
import { LoginForm } from "./loginForm";

export function Navigation() {
    const { isSidebarOpen } = useSidebar();

    return (
        <>
            {/* Sidebar */}
            <div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                {/* Title Section */}
                <div className="sidebar-header">
                    <div className="logo-container">
                        <div className="logo-icon"><img src={"/images/mainLogo.png"} alt="Logo" /></div>
                        <h2 className="site-title">Stardew Croptimizer</h2>
                    </div>
                </div>

                {/* Menu Section */}
                <div className="sidebar-menu">
                    <nav className="nav-list">
                        <Link to="/" className="nav-item">
                            <img className="home-logo" src={"/images/homeLogo.png"} alt="Home" />Home Page
                        </Link>
                        <Link to="/calendars" className="nav-item">
                            <img className="calendar-logo" src={"/images/calendarLogo.png"} alt="Calendars" />Calendars
                        </Link>
                        <Link to="/calculator" className="nav-item">
                            <img className="calculator-logo" src={"/images/calculatorLogo.png"} alt="Calculator" />Profit Calculator
                        </Link>
                    </nav>
                </div>
            </div>
        </>
    )
}

export function Header() {
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    
    return (
        <div className="header-bar">
            <button
                onClick={toggleSidebar}
                className="toggle-button"
                aria-label="Toggle sidebar"
            >
                <svg
                    className="toggle-icon"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    {isSidebarOpen ? (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                    ) : (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                    )}
                </svg>
            </button>

            <span className="header-account">
                <LoginForm />

                <Link to="/signup">
                    <button>Create Account</button>
                </Link>
            </span>

        </div>
    );
}